export default "__VITE_ASSET__C9nlKM9X__"